// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Avatar } from "../Avatar/Avatar";
import { Body } from "../Typography";
import clsx from 'clsx';
export function ListItem(_ref) {
  var _companyName$charAt$t;
  var option = _ref.data,
    innerRef = _ref.innerRef,
    isFocused = _ref.isFocused,
    innerProps = _ref.innerProps;
  var avatarSrc = option.avatarSrc,
    avatarFallbackColor = option.avatarFallbackColor,
    label = option.label,
    type = option.type,
    companyName = option.companyName,
    companyAvatarSrc = option.companyAvatarSrc,
    companyAvatarFallbackColor = option.companyAvatarFallbackColor,
    companyId = option.companyId;
  return /*#__PURE__*/React.createElement("div", _extends({
    key: option.value,
    ref: innerRef
  }, innerProps, {
    className: clsx('cop-flex cop-cursor-pointer cop-items-center cop-gap-3 cop-px-3 hover:cop-bg-gray-100', {
      'cop-h-10': !!companyId,
      // if an option has company to render, the option should have a height of 40px
      'cop-h-8': !companyId,
      // if an option has no company to render, the option should have a height of 32px
      'cop-bg-primary': isFocused
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "cop-relative cop-flex cop-items-baseline"
  }, /*#__PURE__*/React.createElement(Avatar, {
    className: clsx('cop-box-content cop-h-5 cop-w-5', {
      'cop-rounded-[2px]': type === 'company'
    }),
    src: avatarSrc,
    fallbackColor: avatarFallbackColor !== null && avatarFallbackColor !== void 0 ? avatarFallbackColor : '',
    text: label.charAt(0).toLocaleUpperCase(),
    alt: label,
    size: "sm",
    variant: type === 'company' ? 'rounded' : 'circle'
  }), type === 'client' && companyName && /*#__PURE__*/React.createElement(Avatar, {
    src: companyAvatarSrc,
    fallbackColor: companyAvatarFallbackColor !== null && companyAvatarFallbackColor !== void 0 ? companyAvatarFallbackColor : '',
    text: (_companyName$charAt$t = companyName === null || companyName === void 0 ? void 0 : companyName.charAt(0).toLocaleUpperCase()) !== null && _companyName$charAt$t !== void 0 ? _companyName$charAt$t : '',
    alt: label,
    size: "sm",
    variant: "rounded",
    className: "!cop-absolute cop-bottom-[-2px] cop-right-[-2px] cop-box-border cop-h-[10px] cop-w-[10px] cop-rounded-[2px] !cop-text-[8px]",
    fallbackClassName: "!cop-text-[8px] !cop-leading-none"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cop-flex cop-flex-col cop-text-[10px]"
  }, /*#__PURE__*/React.createElement(Body, {
    className: "cop-truncate",
    size: "sm"
  }, option.label), companyName && /*#__PURE__*/React.createElement("span", {
    className: "cop-text-secondary"
  }, companyName)));
}
